// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDVAd5GHsiR72951N2W7VgzED-dv9xV3H8",
  authDomain: "nova-prime-d3c8d.firebaseapp.com",
  projectId: "nova-prime-d3c8d",
  storageBucket: "nova-prime-d3c8d.firebasestorage.app",
  messagingSenderId: "828859651978",
  appId: "1:828859651978:web:2efeb44a9967cd907c5a73",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ EXPORT messaging
export const messaging = getMessaging(app);
